/**
 * @file pages-terms-condition.tsx
 * @module app/modules/setting/pages-terms-condition
 * @description Terms & Conditions sub-tab rendered inside the Pages tab of
 * the new Setting module. Copied from the deprecated
 * app/modules/settings/terms-condition.tsx.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.9
 * @version 1.3.3
 */

import { appSettings } from '../../../api/apiEndPoints';
import { appSettingsToast } from '../../../utils/toast';
import { TermsConditions } from '../../../utils/constants';
import PageContentEditor from './components/page-content-editor';
import usePageContentEditor from './hooks/use-page-content-editor';

/**
 * Terms & Conditions sub-tab component.
 * @returns {JSX.Element} Terms & conditions editor content.
 */
const PagesTermsCondition = () => {
  const editor = usePageContentEditor({
    permissionModule: TermsConditions,
    fetchEndpoint: appSettings.termsCondition,
    saveEndpoint: appSettings.addTermsCondition,
    successToast: appSettingsToast.addTermsCondition,
  });

  return (
    <PageContentEditor
      title="Add / Edit Terms & Conditions"
      contentData={editor.contentData}
      loading={editor.loading}
      fetchLoading={editor.fetchLoading}
      selectedLanguage={editor.selectedLanguage}
      hasViewPermission={editor.hasViewPermission}
      onDataChange={editor.handleDataChange}
      onLanguageChange={editor.handleLanguageChange}
      onSave={editor.handleSave}
    />
  );
};
export default PagesTermsCondition;
